import React, { useState } from 'react';
import { FaChevronRight, FaTh } from 'react-icons/fa';
import Button, { ButtonVariant } from 'components/Button';
import TabBar, { TabType } from './TabBar';
import WidgetSelectTab from './WidgetSelectTab';
import ChatTab from './ChatTab';

interface ActionDrawerProps {
  isSideBarVisible: boolean;
  onToggleOpen: (isOpen: boolean) => void;
}

function ActionDrawer(props: ActionDrawerProps) {
  const [activeTab, setActiveTab] = useState<TabType>(TabType.ADD_ENTRY);

  if (!props.isSideBarVisible) {
    return !props.isSideBarVisible ? (
      <div className="absolute w-fit top-2 right-2">
        <Button
          variant={ButtonVariant.Flat}
          icon={<FaTh />}
          onClick={() => props.onToggleOpen(true)}
          size="md"
        />
      </div>
    ) : null;
  }

  const getTabContent = (tab: TabType) => {
    switch(tab) {
      case TabType.CHAT:
        return <ChatTab />;
      case TabType.ADD_ENTRY:
      default:
        return <WidgetSelectTab/>;
    }
  };

  return props.isSideBarVisible ? (
    <div className="absolute h-full top-0 right-0 max-w-[600px] w-full">
      <div className="flex flex-col p-1 h-full">
        <div className="bg-palette-5 rounded-lg flex flex-col h-full space-y-2">
          <div className="flex flex-row w-full p-1 items-center text-palette-2">
            <div className="flex-1" />
            <Button
              variant={ButtonVariant.FlatNoFill}
              icon={<FaChevronRight />}
              onClick={() => props.onToggleOpen(false)}
              size={"md"}
            />
          </div>
          <div className="flex flex-col h-full overflow-hidden">
            <TabBar
              activeTab={activeTab}
              onSetActiveTab={setActiveTab}
            />
            <div className="flex-1 overflow-y-auto px-2 box-border">
              <div className="w-full h-full">
                {getTabContent(activeTab)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default ActionDrawer;
